/* import __COLOCATED_TEMPLATE__ from './start-timing-association-table.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import dayjs from 'dayjs';

export default class StartTimingAssociationTableComponent extends Component 
{
	@service store;
	@service ajax;
  
	get clearDisabled()
	{
		return this.args.selectedStartTime == null && this.args.selectedStartImpulse == null;
	}
	get associateDisabled()
	{
		return this.args.selectedStartTime == null || this.args.selectedStartImpulse == null;
	}
	get disassociateDisabled()
	{
		return (this.args.selectedStartTime == null || this.args.selectedStartImpulse != null) && (this.args.selectedStartTime != null || this.args.selectedStartImpulse == null);
	}
	
	@action
	async associate()
	{
		
		var sST = this.args.selectedStartTime;
		var sSI = this.args.selectedStartImpulse;

		if(sST == null)
		{
			alert("no start time selected");
			return;
		}
		if(sSI == null)
		{
			alert("no start impulse selected");
			return;
		}
		if(sST.startImpulseId != null)
		{
			alert("start time already has a start impulse");
			return;
		}
		if(sSI.assignedStartTime != null)
		{
			alert("start impulse already has a start time");
			return;
		}
		if(sSI.EntryId != null)
		{
			alert("start impulse already has an entry");
			return;
		}
		
		const response = await this.ajax.request("/start-timing-records/"+sST.id+"/associateWithStartImpulse/"+sSI.id);
		
		if(response.error != null)
			alert(response.error);

		this.args.startTimeSelectAction(null);
		this.args.startImpulseSelectAction(null);
	}
	
	@action
	async disassociate()
	{
		var sST = this.args.selectedStartTime;
		var sSI = this.args.selectedStartImpulse;
		
		//check for valid selectedStartImpulse
		if(sSI != null)
		{
			alert('Start impulse must be cleared');
			return;
		}
		//check for valid selectedStartTime
		if(sST == null)
		{
			alert('No start time selected');
			return;
		}
		if(sST.startImpulseId == null)
		{
			alert('start time has no start impulse');
			return;
		}
		
		const response = await this.ajax.request("/start-timing-records/"+sST.id+"/disassociateStartImpulse");
		
		if(response.error != null)
			alert(response.error);

		this.args.startTimeSelectAction(null);
		this.args.startImpulseSelectAction(null);
	}
	
	@action
	async clearStartTimeAuto()
	{
		var sST = this.args.selectedStartTime;
		var sSI = this.args.selectedStartImpulse;
		
		if(sST == null)
		{
			alert("no start time selected");
			return;
		}
		
		const response = await this.ajax.request("/start-timing-records/"+sST.id+"/removeFromAutoAssociation");
		
		if(response.error != null)
			alert(response.error);
		
		this.args.startTimeSelectAction(null);
		this.args.startImpulseSelectAction(null);
	}
	
	@action
	async setStartTimeAuto()
	{
		var sST = this.args.selectedStartTime;
		var sSI = this.args.selectedStartImpulse;
		
		if(sST == null)
		{
			alert("no start time selected");
			return;
		}
		
		const response = await this.ajax.request("/start-timing-records/"+sST.id+"/addToAutoAssociation");
		
		if(response.error != null)
			alert(response.error);
		
		this.args.startTimeSelectAction(null);
		this.args.startImpulseSelectAction(null);
	}
	
	@action
	async clearStartImpulseAuto()
	{
		var sST = this.args.selectedStartTime;
		var sSI = this.args.selectedStartImpulse;
		
		if(sSI == null)
		{
			alert("no start impulse selected");
			return;
		}
		
		const response = await this.ajax.request("/start-timing-records/"+sSI.id+"/removeFromAutoAssociation");
		
		if(response.error != null)
			alert(response.error);
		
		this.args.startTimeSelectAction(null);
		this.args.startImpulseSelectAction(null);
	}
	
	@action
	async setStartImpulseAuto()
	{
		var sST = this.args.selectedStartTime;
		var sSI = this.args.selectedStartImpulse;
		
		if(sSI == null)
		{
			alert("no start impulse selected");
			return;
		}
		
		const response = await this.ajax.request("/start-timing-records/"+sSI.id+"/addToAutoAssociation");
		
		if(response.error != null)
			alert(response.error);
		
		this.args.startTimeSelectAction(null);
		this.args.startImpulseSelectAction(null);
	}
	
	@action
	clear()
	{
		this.args.startTimeSelectAction(null);
		this.args.startImpulseSelectAction(null);
	}
}
